import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AddressSimilarityResultDto, ProductDto, UserFormOrderFormTypeDto } from '../../../../../../shared/service-proxies/service-proxies';

import { ToRequestWarehouseComponent } from '../wizards/step3/toRequest/to-request-warehouse/to-request-warehouse.component';
import { ToRequestDistributorComponent } from '../wizards/step3/toRequest/to-request-distributor/to-request-distributor.component';
import { FromReceiveWarehouseComponent } from '../wizards/step3/fromReceive/from-receive-warehouse/from-receive-warehouse.component';
import { FromReceiveMobilWarehouseComponent } from '../wizards/step3/fromReceive/from-receive-mobil-warehouse/from-receive-mobil-warehouse.component';
import { ToRequestStaticSalesLocationComponent } from '../wizards/step3/toRequest/to-request-static-sales-location/to-request-static-sales-location.component';
import { ToRequestAddAddressToPersonCategoryComponent } from '../wizards/step3/toRequest/to-request-add-address-to-person-category/to-request-add-address-to-person-category.component';
import { TestService } from '../../../../../../test/service/test.service';
import { ToRequestTransferComponent } from '../wizards/step3/toRequest/to-request-transfer/to-request-transfer.component';

class cardTitleAndSubTitle {

	title: string;
	subTitle: string;
}

Injectable({
    providedIn: "root"
})


export class OrderService{

	
	cardId = new BehaviorSubject<number>(0);

	cardTitleAndSubTitleStep2 = new BehaviorSubject<cardTitleAndSubTitle>(null);

	cardTitleAndSubTitleStep3 = new BehaviorSubject<cardTitleAndSubTitle>(null);

	//userFormCardDto = new BehaviorSubject<UserFormOrderFormTypeDto>(null);

	//benzeşen adres bilgilerini tutar çünki step3 den datayı modal içerisine gönderebilmek için tutuyoruz.
	addressSimilarityList = new BehaviorSubject<AddressSimilarityResultDto[]>([]);

	//Order Kayıt sayfasının ürün listesinde talep miktarlarını tutar. iki componenette kullanılmış olup step3 ve address similarity model componentinde kullanıldı.
	public productList: ProductDto[] = [];

	///////////////BURASI TEST KULLANIMI ASIL YAPIYI DEĞİŞTİRMEDEN ÖNCE////////////////////




	/////////////////////////////////

    constructor(public _testService: TestService) {
        

    }

	
	//#region ComponentName

	public componentName = {
		ToRequestWarehouseComponent: ToRequestWarehouseComponent,
		ToRequestDistributorComponent: ToRequestDistributorComponent,
		FromReceiveWarehouseComponent: FromReceiveWarehouseComponent,
		FromReceiveMobileWarehouseComponent: FromReceiveMobilWarehouseComponent,
		ToRequestSalesStaticLocationComponent: ToRequestStaticSalesLocationComponent,
		AddAddressToPersonCategoryComponent: ToRequestAddAddressToPersonCategoryComponent,
		TransferComponent : ToRequestTransferComponent,
	};

	//#endregion


	public getOrderTitleAndSubtitleWithSession(obj, sessionKey){

		if(obj){
			sessionStorage.setItem(sessionKey, JSON.stringify({title: obj.title, subtitle: obj.subTitle}));
			
		}
		let getSelectCardObj = JSON.parse(sessionStorage.getItem(sessionKey)); //get them back

		return getSelectCardObj;
	}

	public myAlert2(ad:string){
		alert("Merhaba ben servis ici!! " + ad);
	}
  
}
